<template>
  <div class="accordion">
    <button
      @click="toggleAccordion()"
      :aria-expanded="isOpen"
    >
      <div class="flex items-center gap-3">
        <slot name="title" />
        <span class="reset" v-if="reset" @click="resetSelection($event)">
          {{$t('sidebar.reset')}}
        </span>
      </div>
      <img src="@/assets/img/icons/accordion-arrow.svg" alt="icon"
        class="w-4 transition-all duration-200 transform mb-1"
        :class="{
          'rotate-180': !isOpen,
          'rotate-0': isOpen,
        }"
        v-if="!hideArrow"
      >
    </button>

    <div v-show="isOpen" class="accordion-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  props: ['hideArrow', 'openByDefault', 'reset'],
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
    resetSelection($event) {
      $event.stopPropagation();
      this.$emit("reset");
    },
  },
  mounted() {
    if (this.openByDefault) {
      this.isOpen = true;
    }
  },
};
</script>


<style scoped>
.clear button {
  background-color: transparent;
  padding: 0;
}

.reset{
    @apply border border-adviz-primary rounded px-2 py-0 text-xs leading-5 hover:bg-adviz-primary hover:text-white cursor-pointer transition-all duration-200;
 }
</style>